export const DELETE_SANDBOX_URL =
  'https://support.atlassian.com/organization-administration/docs/manage-product-sandboxes/#Delete-a-sandbox';
